import script from "./BTableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BTableHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BTableHeader.vue?vue&type=style&index=0&id=0626ca33&lang=scss"

const __exports__ = script;

export default __exports__